import tolgee from '@/tolgee.js';

/**
 * Translation composable - replaces $ct and $t from global mixin
 */
export function useTranslation() {
  /**
   * Custom translation with error tracking
   * Replaces this.$ct()
   */
  const ct = (key: string, params: Record<string, any> = {}) => {
    const translation = tolgee.t(key, params);

    // Check for missing translation keys
    if (/[^ \t]\.[^ \t]/.test(translation)) {
      window?.faro?.api?.pushError(new Error(`Missing tolgee key ${translation}`));
    }

    return translation;
  };

  /**
   * Standard translation
   * Replaces this.$t()
   */
  const t = (key: string, params: Record<string, any> = {}) => {
    return tolgee.t(key, params);
  };

  return {
    ct,
    t
  };
}
